import { render, staticRenderFns } from "./matrixType.vue?vue&type=template&id=2e34ec2e&scoped=true"
import script from "./matrixType.vue?vue&type=script&lang=js"
export * from "./matrixType.vue?vue&type=script&lang=js"
import style0 from "./matrixType.vue?vue&type=style&index=0&id=2e34ec2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e34ec2e",
  null
  
)

export default component.exports